import axios from 'axios';

import { JOURNEY_API } from 'Constants';
import { Journey } from 'Global/Journey/Types/Journey';
import { JourneySchedule } from 'Global/Journey/Types/JourneySchedule';
import {
	ILocationEntityAttributes,
	IRouteEntityAttributes,
	ISegmentEntityAttributes,
	IStopEntityAttributes,
	LocationEntity,
	RouteEntity,
	SegmentEntity,
	StopEntity,
} from 'Models/Entities';
import { buildUrl } from 'Util/FetchUtils';
import { JourneyElementsDto } from '../Types/JourneyElementsDto';

interface JourneyElementsDtoPartial {
	locations: Partial<ILocationEntityAttributes>[];
	routes: Partial<IRouteEntityAttributes>[];
	segments: Partial<ISegmentEntityAttributes>[];
	stops: Partial<IStopEntityAttributes>[];
}

export async function fetchJourneyElements(): Promise<JourneyElementsDto> {
	const results = await axios.get<JourneyElementsDtoPartial>(buildUrl(`${JOURNEY_API}/elements`));

	return {
		locations: results.data.locations.map(x => new LocationEntity(x)),
		routes: results.data.routes.map(x => new RouteEntity(x)),
		segments: results.data.segments.map(x => new SegmentEntity(x)),
		stops: results.data.stops.map(x => new StopEntity(x)),
	};
}

export const getJourneySchedule = async (journey: Journey) => {
	const { tripId, startStopId, endStopId } = journey;
	const url = buildUrl(`${JOURNEY_API}/schedule`, { tripId, startStopId, endStopId });
	const result = await axios.get<JourneySchedule>(url);
	return {
		departureDateTime: new Date(result.data.departureDateTime),
		arrivalDateTime: new Date(result.data.arrivalDateTime),
	};
};
